var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ensemble"},[_c('div',{style:({ 'height': _vm.imgHeight + 'vh', 'width': _vm.imgWidth + 'vh' })},[_c('img',{staticClass:"picImgStyle",attrs:{"src":_vm.picImg,"alt":"设置照片地址"}})]),_vm._v(" "),_c('div',{staticClass:"textFrame",style:({ 'width': _vm.imgWidth + 'vh', backgroundColor: _vm.textBackground })},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79b0fa24","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/imgAndText.vue
// module id = null
// module chunks = 